<lvr-nav-carousel [backLink]="backLink()" [carouselElements]="carouselElements()" [showCarousel]="false">
</lvr-nav-carousel>

<lvr-heading (editClicked)="openEdit()" [showEditButton]="resolvedShowEditButton()">
	<div [matTooltip]="'assignment.details.send_mail_tooltip' | transloco" ngProjectAs="button-content">
		<lvr-button
			variant="primary"
			[label]="'base.button.send' | transloco"
			[ariaLabel]="'assignment.details.send_mail_tooltip' | transloco"
			[type]="'button'"
			(clicked)="openMail('')"
			icon="forward_to_inbox"
		></lvr-button>
	</div>
	<span class="title">{{ 'assignment.additional.details_title' | transloco }}</span>
</lvr-heading>

@let entity = assignment();
@if (entity) {
	<table>
		<tr>
			<th scope="col">{{ 'assignment.create_additional.startOfCare' | transloco }}:</th>
			<th scope="col">{{ 'base.field.type_of_care' | transloco }}:</th>
		</tr>
		<tr>
			<td>{{ entity.careStartDate ? (entity.careStartDate | date: 'dd.MM.yyyy') : '-' }}</td>
			<td>{{ entity.typeOfCare?.remark ?? '-' }}</td>
		</tr>
		<tr>
			<th scope="col">{{ 'base.field.type_of_disability_relevant_to_care' | transloco }}:</th>
			@if (canReadAssignmentDocuments()) {
				<th scope="col">{{ 'base.field.documents' | transloco }}:</th>
			}
		</tr>
		<tr>
			<td>{{ entity.careRelatedHandicap?.disabilityType?.remark ?? '-' }}</td>
			@if (canReadAssignmentDocuments()) {
				<td class="documents-list">
					@if ((entity.documents ?? []).length === 0) {
						-
					} @else {
						<ul>
							@for (doc of entity.documents ?? []; track doc.id) {
								<li>
									<lvr-document-item
										[document]="buildDocumentEntryFromAssignment(doc)!"
										(open)="onFileClick(doc)"
									></lvr-document-item>
								</li>
							}
						</ul>
					}
				</td>
			}
		</tr>
		<tr>
			@if (assignment()?.phaseId !== PHASE1) {
				<th>{{ 'assignment.details.impediment_due_date' | transloco }}</th>
			}
			<th>{{ 'user.assignment_transfer.assignment_number' | transloco }}:</th>
		</tr>
		<tr>
			@if (assignment()?.phaseId !== PHASE1) {
				<td>
					{{
						assignment()?.impedimentReportDueDate ? (assignment()?.impedimentReportDueDate | date: 'dd.MM.yyyy') : '-'
					}}
				</td>
			}
			<td>{{ entity.guid }}</td>
		</tr>
		@if (assignment()?.phaseId === PHASE4) {
			<tr>
				<th>{{ 'assignment.details.cancellation_date' | transloco }}:</th>
			</tr>
			<tr>
				<td>
					{{ assignment()?.cancellationDate ? (assignment()?.cancellationDate | date: 'dd.MM.yyyy') : '-' }}
				</td>
			</tr>
		}
	</table>
}

@if (showReports()) {
	<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">
		<span style="margin-right: 8px">{{ 'assignment.details.reports' | transloco }}</span>
	</h2>
	@if (canEditAssignment() && canCreateReportsPermission()) {
		<lvr-action-menu [items]="menuItems()"></lvr-action-menu>
	}

	@if (reports().length === 0) {
		<p lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'assignment.details.no_reports' | transloco }}</p>
	} @else {
		<div class="report-list">
			@for (report of reports(); track report.id) {
				<button class="report-row" [disabled]="!canReadReportsPermission()" (click)="openReport(report)">
					<span class="report-title-group">
						<b class="report-category">{{ report.categoryReport.description }}</b>
						<div>
							<span class="report-created">{{ 'assignment.details.report_created' | transloco }}:</span>
							<span class="report-date">
								{{ report.createdAt | date: 'dd.MM.yyyy' }}
							</span>
						</div>
					</span>
					<mat-chip class="chip-default">
						@if (report.isFinal) {
							{{ 'assignment.details.finished_report' | transloco }}
						} @else if (!report.isFinal && report.isDraft) {
							{{ 'assignment.details.draft_report' | transloco }}
						} @else if (!report.isFinal && !report.isDraft) {
							{{ 'assignment.details.ready_report' | transloco }}
						}
					</mat-chip>
				</button>
			}
		</div>
	}
}
